import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { userActions } from 'shared-lib'

export const SIGNED_OUT_MESSAGE_KEY = 'employer.signedOutMessage'
export const CLIENT_SESSION_ENDED_MESSAGE = 'Your client session ended. Please sign in again.'
export const SIGNED_OUT_MESSAGE = 'You were signed out. Please sign in again.'

const SESSION_GONE_AUTH_CODES = ['auth/user-token-expired', 'auth/user-disabled', 'auth/user-not-found', 'auth/invalid-user-token']

export function isSessionGoneError(err: unknown): boolean {
  const e = err as any
  const status = e?.response?.status ?? e?.status ?? e?.errorData?.statusCode
  if (status === 401 || status === 403) return true
  const code = e?.code ?? e?.errorData?.code
  return typeof code === 'string' && SESSION_GONE_AUTH_CODES.includes(code)
}

@Injectable({
  providedIn: 'root',
})
export class AccountSessionService {
  private expectingAccountChange = false
  private endingSession = false
  pendingSignedOutMessage: string | null = null

  constructor(private store: Store) {}

  get isEndingSession(): boolean {
    return this.endingSession
  }

  expectAccountChange(): void {
    this.expectingAccountChange = true
  }

  cancelExpectedAccountChange(): void {
    this.expectingAccountChange = false
  }

  consumeExpectedAccountChange(): boolean {
    const expected = this.expectingAccountChange
    this.expectingAccountChange = false
    return expected
  }

  noteLoggingOut(): void {
    this.endingSession = true
  }

  endSession(message: string): void {
    if (this.endingSession) return
    this.pendingSignedOutMessage = message
    this.store.dispatch(userActions.OnLogOut())
    this.endingSession = true
  }
}
